import React, { PropTypes } from 'react';
import { PromiseState } from 'react-refetch';
import { PromiseStateContainer, CardContainer } from '../../components';

const CardFetchContainer = ({ fetch, title, iconUrl, alt, linkText, link, isNews }) => (
  <PromiseStateContainer
    ps={PromiseState.race([fetch])}
    onFulFillment={response => (
      <CardContainer
        title={title}
        iconUrl={iconUrl}
        alt={alt}
        linkText={linkText}
        link={link}
        items={response}
        isNews={isNews}
      />
    )}
  />
);

CardFetchContainer.propTypes = {
  fetch: PropTypes.instanceOf(PromiseState).isRequired,
  title: PropTypes.string.isRequired,
  iconUrl: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  isNews: PropTypes.bool
};

export default CardFetchContainer;



// WEBPACK FOOTER //
// ./src/pages/press/components/CardFetchContainer/CardFetchContainer.js